import * as React from 'react';
import { useLayoutEffect, useRef, useState } from 'react';
import {
  type PdfSelection,
  usePdfHighlighterContext,
} from 'react-pdf-highlighter-extended';
import {
  FieldCorrectionForm,
  FormFieldCorrection,
} from '~/components/ui/vendor/pdf/document_pdf_viewer/FieldCorrectionForm';
import type { DocumentFieldDefinition } from '~/lib/document_field';
import { BoundingBox } from '~/lib/pdfViewer/types';

interface ExpandableTipProps {
  // addHighlight: (highlight: GhostHighlight, data: FormFieldCorrection) => void;
  addHighlight: (highlight: BoundingBox, data: FormFieldCorrection) => void;
  fieldTypes: DocumentFieldDefinition[];
}

export const ExpandableTip = ({
  addHighlight,
  fieldTypes,
}: ExpandableTipProps) => {
  const [compact, setCompact] = useState(true);
  const {
    getCurrentSelection,
    removeGhostHighlight,
    setTip,
    updateTipPosition,
    getGhostHighlight,
    getViewer,
  } = usePdfHighlighterContext();

  // TODO: This ref use is very weird.... consider useState instead if anything at all
  const selectionRef = useRef<PdfSelection | null>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Actually want to react on compact change, yes weird
  useLayoutEffect(() => {
    // biome-ignore lint/style/noNonNullAssertion: This code is as-is from react-pdf-highlighter-extended example
    updateTipPosition?.();
  }, [compact, updateTipPosition]);

  return (
    <div className="tip">
      {compact ? (
        <button
          type="button"
          className="compact"
          onClick={() => {
            setCompact(false);
            const selection = getCurrentSelection();
            console.log('selection', selection);
            if (selection === null) {
              console.error('No selection, should not be possible');
              return;
            }
            selectionRef.current = selection;
            selection.makeGhostHighlight();
            const ghostHighlight = getGhostHighlight();
            console.log('ghostHighlight', ghostHighlight);
            const viewer = getViewer();
            console.log('viewer', viewer);
            const currentScale = viewer?.currentScale;
            console.log('currentScale', currentScale);
            const pageViewer = viewer?.getPageView(viewer?.currentPageNumber);
            console.log('pageViewer', pageViewer);
            const pageDimentions = pageViewer?.viewport.viewBox; //[0,0,596,842] { x: 0, y: 0, width: 595.276, height: 841.89 }
            console.log('pageDimentions', pageDimentions);
            // const pageScale = pageViewer?.viewport.scale; //1.6666666666666665
            // const rawDimensions = pageViewer?.viewport.convertToViewportRectangle(ghostHighlight.position.boundingRect);
            const rawDimensions = pageViewer?.viewport.rawDims;
            console.log('rawDimensions', rawDimensions);
            // const canvasWidth = pageViewer?.canvas.width; // 1240
            // const canvasHeight = pageViewer?.canvas.width; // 1750
          }}
        >
          Add correction
        </button>
      ) : (
        <FieldCorrectionForm
          fieldTypes={fieldTypes}
          defaultText={selectionRef.current?.content.text}
          close={() => setTip(null)}
          onSubmit={(data) => {
            const selection = selectionRef.current;
            if (selection === null) {
              throw new Error('Expected a selection');
            }
            const viewer = getViewer();
            const currentScale = viewer?.currentScale;
            // const pageViewer = viewer?.getPageView(viewer?.currentPageNumber);

            if (currentScale === undefined) {
              throw new Error('Expected a current scale');
            }
            addHighlight(
              positionRescale(selection.position.boundingRect, currentScale),
              // {
              //   content: selection.content,
              //   type: selection.type,
              //   position: positionRescale(selection.position.boundingRect, currentScale),
              // },
              data,
              // fetcher,
            );

            removeGhostHighlight();
          }}
        />
      )}
    </div>
  );
};
/**
 * Rescale the position of a bounding box to 100% scale
 * @param position - The position to rescale
 * @param currentScale - The current scale of the position from viewer current scale
 */
const positionRescale = (
  position: BoundingBox,
  _currentScale: number,
): BoundingBox => {
  return {
    ...position,
    y1: position.y1 / position.height, //*1000,
    y2: position.y2 / position.height, //*1000,
    x1: position.x1 / position.width, //*1000,
    x2: position.x2 / position.width, //*1000,
  };
};
